/*
 * Copyright 2025 Oddpods
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 *
 * See https://github.com/oddpods/cauce/blob/main/LICENSE
 */
package studio.oddpods.cauce.core.designsystem.theme

import androidx.compose.ui.graphics.Color

// region Light
val primaryLight = Color(0xFF1C6B6B) // Teal 700
val onPrimaryLight = Color(0xFFFFFFFF)
val primaryContainerLight = Color(0xFFC4E4E4) // Teal 100
val onPrimaryContainerLight = Color(0xFF0A3333) // Teal 900
val secondaryLight = Color(0xFF3B5050) // Neutral 700
val onSecondaryLight = Color(0xFFFFFFFF)
val secondaryContainerLight = Color(0xFFE2EDED) // Neutral 100
val onSecondaryContainerLight = Color(0xFF1A2828) // Neutral 900
val tertiaryLight = Color(0xFFC2694A) // Terracota 500
val onTertiaryLight = Color(0xFFFFFFFF)
val tertiaryContainerLight = Color(0xFFF0D9D1) // Terracota 100
val onTertiaryContainerLight = Color(0xFF7A3020) // Terracota 700
val errorLight = Color(0xFFAC3A3A)
val onErrorLight = Color(0xFFFFFFFF)
val errorContainerLight = Color(0xFFFDECEA)
val onErrorContainerLight = Color(0xFF410002)
val backgroundLight = Color(0xFFF2F8F8) // App bg
val onBackgroundLight = Color(0xFF1A2828) // Neutral 900
val surfaceLight = Color(0xFFFFFFFF)
val onSurfaceLight = Color(0xFF1A2828) // Neutral 900
val surfaceVariantLight = Color(0xFFEAF5F5) // Teal 50
val onSurfaceVariantLight = Color(0xFF3B5050) // Neutral 700
val outlineLight = Color(0xFF99ABAB) // Neutral 300
val outlineVariantLight = Color(0xFFC7DDDD) // Neutral 200 / border
val scrimLight = Color(0xFF000000)
val inverseSurfaceLight = Color(0xFF1A2828) // Neutral 900
val inverseOnSurfaceLight = Color(0xFFE2EDED) // Neutral 100
val inversePrimaryLight = Color(0xFFC4E4E4) // Teal 100
val surfaceDimLight = Color(0xFFD4E8E8)
val surfaceBrightLight = Color(0xFFFFFFFF)
val surfaceContainerLowestLight = Color(0xFFFFFFFF)
val surfaceContainerLowLight = Color(0xFFF2F8F8) // App bg
val surfaceContainerLight = Color(0xFFEAF5F5) // Teal 50
val surfaceContainerHighLight = Color(0xFFE2EDED) // Neutral 100
val surfaceContainerHighestLight = Color(0xFFD4E8E8)
// endregion

// region Dark
val primaryDark = Color(0xFFC4E4E4) // Teal 100
val onPrimaryDark = Color(0xFF0A3333) // Teal 900
val primaryContainerDark = Color(0xFF135252) // Teal 800
val onPrimaryContainerDark = Color(0xFFC4E4E4) // Teal 100
val secondaryDark = Color(0xFFC7DDDD) // Neutral 200
val onSecondaryDark = Color(0xFF1A2828) // Neutral 900
val secondaryContainerDark = Color(0xFF3B5050) // Neutral 700
val onSecondaryContainerDark = Color(0xFFE2EDED) // Neutral 100
val tertiaryDark = Color(0xFFDFA088) // Terracota 300
val onTertiaryDark = Color(0xFF7A3020) // Terracota 700
val tertiaryContainerDark = Color(0xFF5C2210)
val onTertiaryContainerDark = Color(0xFFF0D9D1) // Terracota 100
val errorDark = Color(0xFFFFB4AB)
val onErrorDark = Color(0xFF690005)
val errorContainerDark = Color(0xFF93000A)
val onErrorContainerDark = Color(0xFFFFDAD6)
val backgroundDark = Color(0xFF0F1C1C)
val onBackgroundDark = Color(0xFFE2EDED) // Neutral 100
val surfaceDark = Color(0xFF131F1F)
val onSurfaceDark = Color(0xFFE2EDED) // Neutral 100
val surfaceVariantDark = Color(0xFF1A2828) // Neutral 900
val onSurfaceVariantDark = Color(0xFFC7DDDD) // Neutral 200
val outlineDark = Color(0xFF607272) // Neutral 500
val outlineVariantDark = Color(0xFF3B5050) // Neutral 700
val scrimDark = Color(0xFF000000)
val inverseSurfaceDark = Color(0xFFE2EDED) // Neutral 100
val inverseOnSurfaceDark = Color(0xFF1A2828) // Neutral 900
val inversePrimaryDark = Color(0xFF1C6B6B) // Teal 700
val surfaceDimDark = Color(0xFF0F1C1C)
val surfaceBrightDark = Color(0xFF253535)
val surfaceContainerLowestDark = Color(0xFF0A1414)
val surfaceContainerLowDark = Color(0xFF131F1F)
val surfaceContainerDark = Color(0xFF162222)
val surfaceContainerHighDark = Color(0xFF1C2B2B)
val surfaceContainerHighestDark = Color(0xFF223333)
// endregion
